import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import CryptoJS from "crypto-js";
import { useChatStore } from "./useChatStore";

// Kunci enkripsi rahasia (Bisa disimpan di .env)
const SECRET_KEY = import.meta.env.VITE_CRYPTO_SECRET_KEY || "llm-secret-key-12345";

// Custom Encrypted Storage Adapter
const encryptedStorage = {
    getItem: (name: string): string | null => {
        const encryptedData = localStorage.getItem(name);
        if (!encryptedData) return null;

        try {
            const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            return decryptedData || null;
        } catch {
            // Jika user mencoba merusak data enkripsi di DevTools
            console.warn("Data storage terindikasi dimanipulasi!");
            localStorage.removeItem(name);
            return null;
        }
    },
    setItem: (name: string, value: string): void => {
        const encryptedData = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
        localStorage.setItem(name, encryptedData);
    },
    removeItem: (name: string): void => {
        localStorage.removeItem(name);
    },
};

interface LLMLimitState {
    date: string;
    count: number;       // jumlah request LLM hari ini
    maxPerDay: number;   // batas maksimal per hari
    canUseLLM: () => boolean;
    incrementUsage: () => void;
    getRemaining: () => number;
    resetIfNewDay: () => void;
}

const getTodayString = () => {
    // format lokal browser, contoh: "dd/MM/yyyy"
    const now = new Date();
    return now.toLocaleDateString("id-ID");
};

export const useLLMLimitStore = create<LLMLimitState>()(
    persist(
        (set, get) => ({
            date: getTodayString(),
            count: 0,
            maxPerDay: 5, // ganti sesuai kebutuhan

            resetIfNewDay: () => {
                const today = getTodayString();
                if (get().date !== today) {
                    set({ date: today, count: 0 });
                }
            },

            canUseLLM: () => {
                get().resetIfNewDay();
                return get().count < get().maxPerDay;
            },

            incrementUsage: () => {
                // 1. reset jika sudah ganti haru
                get().resetIfNewDay();

                // 2. Ambil state saat ini
                const { count, maxPerDay } = get();
                const nextCount = count + 1;
                // 3. Update state internal store saat ini
                set({ count: nextCount });
                if (nextCount === maxPerDay) {
                    console.log("change");
                    useChatStore.getState().setChatType('tfjs');
                }
            },

            getRemaining: () => {
                get().resetIfNewDay();
                return Math.max(0, get().maxPerDay - get().count);
            },
        }),
        {
            name: "llm-limit-storage",
            storage: createJSONStorage(() => encryptedStorage), // Menggunakan enkripsi custom
            // Hanya simpan state data saja (bukan fungsi)
            partialize: (state) => ({
                date: state.date,
                count: state.count,
                maxPerDay: state.maxPerDay,
            }),
        }
    )
);